import Item from "./item";

export default class List {
	_items: Array<Item>;

	_dom: {
		container: DocumentFragment;
	};

	constructor(docs) {
		this._dom = {
			container: Mapy.Util.fragment(),
		};

		this._items = [];

		const single = docs.length === 1;
		const onOpen = item => {
			this._items.forEach(it => {
				it.open = it === item;
			});
		};

		docs.forEach((doc, index) => {
			const item = new Item(doc, {
				single,
				open: index === 0,
				onOpen,
			});

			this._items.push(item);
			this._dom.container.appendChild(item.container);
		});
	}

	destroy() {
		this._items.forEach(item => item.destroy());
		this._items = [];
	}

	get container() {
		return this._dom.container;
	}
}
